<template>
  <v-dialog
    v-model="visible"
    persistent
    :max-width="maxWidth"
    overlay-opacity="0.8"
  >
    <v-card class="card-shadow border-radius-xl">
      <v-card-title class="text-center pt-6 pb-2">
        {{ title }}
      </v-card-title>
      <v-card-text class="py-4" :class="messageAlignClass">
        <div class="confirm-dialog__message-wrapper" :style="messageWrapperStyle">
          <p
            class="text-body-1 text-typo mb-0 confirm-dialog__message"
            v-html="formattedMessage"
          ></p>
        </div>
      </v-card-text>
      <v-card-actions class="pb-6 px-6">
        <v-spacer></v-spacer>
        <v-btn
          class="
            font-weight-bold
            text-capitalize
            btn-ls btn-secondary
            bg-gradient-light
            py-3
            px-6
          "
          text
          @click="onNoClick"
        >
          {{ noButtonText }}
        </v-btn>
        <v-btn
          class="
            font-weight-bold
            text-capitalize
            btn-primary
            bg-gradient-primary
            py-3
            px-6
          "
          @click="onYesClick"
        >
          {{ yesButtonText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ConfirmDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Confirm",
    },
    message: {
      type: String,
      default: "Are you sure you want to proceed?",
    },
    maxWidth: {
      type: [Number, String],
      default: 400,
    },
    messageMaxHeight: {
      type: String,
      default: "",
    },
    messageAlign: {
      type: String,
      default: "center",
    },
    yesButtonText: {
      type: String,
      default: "Yes",
    },
    noButtonText: {
      type: String,
      default: "No",
    },
    yesCallback: {
      type: Function,
      default: null,
    },
  },
  computed: {
    formattedMessage() {
      return (this.message || "").replace(/\n/g, "<br />");
    },
    messageAlignClass() {
      return this.messageAlign === "left" ? "text-left" : "text-center";
    },
    messageWrapperStyle() {
      if (!this.messageMaxHeight) return {};
      return {
        maxHeight: this.messageMaxHeight,
        overflowY: "auto",
      };
    },
  },
  methods: {
    onYesClick() {
      if (this.yesCallback) {
        this.yesCallback();
      }
      this.$emit("update:visible", false);
      this.$emit("yes-clicked");
    },
    onNoClick() {
      this.$emit("update:visible", false);
      this.$emit("no-clicked");
    },
  },
};
</script>

<style scoped>
.v-card-actions {
  justify-content: flex-end;
}

.confirm-dialog__message {
  white-space: pre-line;
}
</style>
